/** The parent <Tabs> component accecesses this component's propeties directly in order to present each Tab */
export const Tab = (_props) => null;
Tab.displayName = 'Tab';
//# sourceMappingURL=Tab.js.map